export const deliverables = {
  export: {
    trigger: 'Exportar',
    copyHeading: 'Copiar URLs',
    copyMonth: 'Copiar URLs — mes actual',
    copyAll: 'Copiar URLs — todos los meses',
    csvHeading: 'Descargar CSV',
    csvMonth: 'CSV — mes actual',
    csvAll: 'CSV — todos los meses',
    copied: 'URLs copiadas: {{withUrl}} de {{total}} entregables con URL',
    downloaded: 'CSV descargado ({{count}} entregables)',
    noUrls: 'Ningún entregable tiene URL cargada todavía.',
    noItems: 'No hay entregables para exportar.',
    error: 'No se pudo exportar. Intentá de nuevo.',
  },
  overview: {
    title: 'Entregables',
    description: 'Tracking mensual de entregables por cliente',
    monthLabel: 'Mes',
    columns: {
      organization: 'Cliente',
      nota: 'Notas',
      optimizacion: 'Optimizaciones',
      landing: 'Landings',
      backlink: 'Backlinks',
      interaccion_hilo: 'Hilos',
    },
    empty: 'Aún no se cargaron entregables para este mes.',
    error: 'No se pudieron cargar los entregables.',
    loading: 'Cargando entregables…',
    noTarget: 'Sin meta',
    approvedShort: 'Aprob.',
    publishedShort: 'Public.',
  },
  detail: {
    back: 'Volver',
    monthLabel: 'Mes',
    notFound: 'No se encontró el cliente solicitado.',
    goalsTitle: 'Metas del mes',
    goalsDescription: 'Define cuántos entregables esperás cumplir este mes.',
    goalsSaveButton: 'Guardar metas',
    goalsSaving: 'Guardando…',
    goalsSaved: 'Metas actualizadas',
    goalsError: 'No se pudieron guardar las metas',
    itemsTitle: 'Entregables',
    addItem: 'Agregar entregable',
    editCount: 'Editar cantidad',
  },
  sections: {
    goalLabel: 'Meta',
  },
  types: {
    nota: { label: 'Notas', short: 'Notas', singular: 'Nota' },
    optimizacion: { label: 'Optimizaciones', short: 'Opt.', singular: 'Optimización' },
    landing: { label: 'Landings', short: 'Landings', singular: 'Landing' },
    backlink: { label: 'Backlinks', short: 'BL', singular: 'Backlink' },
    interaccion_hilo: { label: 'Hilos / Interacciones', short: 'Hilos', singular: 'Interacción en hilo' },
  },
  statuses: {
    nota: {
      created: 'Creada',
      in_client_review: 'En revisión del cliente',
      approved: 'Aprobada',
    },
    optimizacion: {
      pending: 'Pendiente',
      done: 'Hecha',
    },
    landing: {
      pending: 'Pendiente',
      done: 'Hecha',
    },
    backlink: {
      pending: 'Pendiente',
      done: 'Hecho',
    },
    interaccion_hilo: {
      pending: 'Pendiente',
      published: 'Publicada',
    },
  },
  platforms: {
    reddit: 'Reddit',
    linkedin: 'LinkedIn',
    x: 'X',
    otro: 'Otro',
  },
  filter: {
    label: 'Filtrar por estado',
    all: 'Todos los estados',
  },
  comments: {
    title: 'Comentarios del equipo',
    placeholder: 'Dejá una nota para el equipo…',
    add: 'Agregar comentario',
    empty: 'Sin comentarios todavía.',
    delete: 'Eliminar comentario',
  },
  missing: {
    title: '{{count}} contenidos del plan sin entregable',
    syncButton: 'Sincronizar plan',
    syncing: 'Sincronizando…',
    syncSuccess: 'Se crearon {{count}} entregables desde el plan.',
    syncError: 'No se pudo sincronizar el plan de contenidos.',
  },
  form: {
    title: 'Título',
    titlePlaceholder: 'Ingresá un título',
    objective: 'Objetivo',
    objectivePlaceholder: 'Qué buscamos lograr con este entregable',
    url: 'Link de referencia',
    urlPlaceholder: 'https://…',
    status: 'Estado',
    notes: 'Detalle',
    notesPlaceholder: 'Detalle del entregable',
    owner: 'Responsable',
    ownerNone: 'Sin responsable',
    ownerSearch: 'Buscar persona…',
    ownerEmpty: 'No hay personas disponibles.',
    clientDeliveryDate: 'Día de entrega al cliente',
    sourceUrl: 'URL de origen (backlink)',
    sourceUrlPlaceholder: 'https://medio.com/articulo',
    platform: 'Plataforma',
    save: 'Guardar',
    saving: 'Guardando…',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    deleteConfirm: '¿Eliminar este entregable?',
    deleteConfirmDescription: 'Esta acción no se puede deshacer.',
    createTitle: 'Nuevo entregable',
    editTitle: 'Editar entregable',
    typeLabel: 'Tipo',
    required: 'Campo obligatorio',
    invalidUrl: 'URL inválida',
  },
  items: {
    empty: 'Sin entregables de este tipo.',
    noneForFilter: 'Ningún entregable coincide con el filtro.',
    edit: 'Editar',
    delete: 'Eliminar',
    none: '—',
    openUrl: 'Abrir link',
    expand: 'Expandir entregable',
    collapse: 'Colapsar entregable',
    published: 'Publicado',
    notPublished: 'Sin publicar',
    markPublished: 'Marcar como publicado',
    markUnpublished: 'Marcar como sin publicar',
  },
  setCount: {
    title: 'Editar cantidad de {{type}}',
    description: 'Cantidad actual: {{count}}. Definí cuántos entregables hay este mes.',
    fieldLabel: 'Nueva cantidad',
    decrement: 'Restar uno',
    increment: 'Sumar uno',
    willCreate: 'Se crearán {{count}} entregables nuevos.',
    willDelete:
      'Se eliminarán los últimos {{count}} entregables cargados. Esta acción no se puede deshacer.',
    noChange: 'Sin cambios respecto al valor actual.',
    outOfRange: 'Ingresá un número entre 0 y {{max}}.',
    save: 'Guardar',
    saving: 'Guardando…',
    success: 'Cantidad actualizada',
    error: 'No se pudo actualizar la cantidad',
  },
  toasts: {
    itemCreated: 'Entregable creado',
    itemUpdated: 'Entregable actualizado',
    itemDeleted: 'Entregable eliminado',
    commentAdded: 'Comentario agregado',
    commentDeleted: 'Comentario eliminado',
    published: 'Marcado como publicado',
    unpublished: 'Marcado como sin publicar',
    error: 'Ocurrió un error',
  },
  client: {
    kicker: 'Este mes',
    title: 'Avance de entregables',
    subtitle: 'Acá podés ver el progreso de los entregables que tu equipo de SEO está produciendo este mes.',
    itemsTitle: 'Entregables del mes',
    empty: 'Aún no hay entregables cargados para este mes.',
    error: 'No pudimos cargar el avance.',
    approvedCount: '{{count}} aprobadas',
    publishedCount: '{{count}} publicadas',
    fields: {
      objective: 'Objetivo',
      detail: 'Detalle',
      status: 'Status',
      owner: 'Owner',
      deliveryDate: 'Fecha de entrega',
      referenceLink: 'Link de referencia',
    },
    steps: {
      published: 'Publicada',
      nota: {
        created: 'Borrador',
        in_client_review: 'Enviada',
        approved: 'Aprobada',
      },
      optimizacion: {
        pending: 'Pendiente',
        done: 'Hecha',
      },
      landing: {
        pending: 'Pendiente',
        done: 'Hecha',
      },
      backlink: {
        pending: 'Pendiente',
        done: 'Hecho',
      },
      interaccion_hilo: {
        pending: 'Pendiente',
        published: 'Publicada',
      },
    },
  },
}
